import styled from 'styled-components';
import { GREY_300, GREY_500, GREY_800 } from '../../../constants';

export const ReminderDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0.5rem 1.5rem;
    gap: 1.5rem;
`;

export const ReminderHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.5rem 0 1rem;
`;

export const ReminderSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1rem;
`;

export const ReminderSectionTitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${GREY_800};
    margin: 0;
    padding-bottom: 0.5rem;
`;

export const ReminderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const DetailLabel = styled.span`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${GREY_500};
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
`;

export const DetailValue = styled.div`
    font-size: 1rem;
    color: ${GREY_300};
    word-break: break-word;
    line-height: 1.5;
    font-weight: 200;
    letter-spacing: 0.25px;
    
    /* Ensure nested DateTimeColumn components display properly */
    > div {
        padding: 0;
    }
`;
